import { gql } from "@apollo/client";

const assetInformation = gql`
  fragment assetInformation on AssetInformation {
    id
    documentDetailId
    siteId
    orderNo
    chassisNumber
    orderNumber
  }
`;

export const documentDetail = gql`
  fragment documentDetail on DocumentDetail {
    documentDetailId
    siteId
    itemId
    item {
      id
      code
      name
      typeId
      typeCode
      typeName
    }
    totalAmountWithVAT
    quantity
    chassisNumber
    isSecondHand
    kilometers
    manufacturingMonth
    manufacturingYear
    assetWeight
    assetHierarchy {
      id
    }
    currencyId
    currencyCode
    insuranceSimulations {
      id
      documentDetailId
      documentDetailSiteId
      insuranceTypeId
      insuranceTypeCode
      insuranceTypeName
      periodicity
      currencyCode
      selectedInsuranceQuotationId
      rtiEligible
      assetInformationId
      currentPolicyMaintained
      insuredAmount
      hasRtiOption
      rtiOption {
        insuranceSimulationId
        insuranceAmount
        periodicity
        insurerName
      }
      selectedQuotation {
        id
        insurerId
        insurerName
        currencyCode
        period
        rcaQuotation {
          id
          selectedDetail {
            id
            insuranceAmount
          }
        }
        cascoQuotation {
          id
          insuranceAmount
          periodicity
        }
      }
    }
    assetInformation {
      ...assetInformation
    }
  }
  ${assetInformation}
`;

export const associatedRisk = gql`
  fragment associatedRisk on AssociatedRisk {
    id
    insuranceQuotationId
    typeId
    typeName
    selected
    readOnly
    mandatory
  }
`;
